import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const useExportToExcel = () => {
  const exportToExcel = ({ data, fileName = 'data_export' }: { data: any[]; fileName: string }) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the object data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate an Excel file as an array buffer
    const excelBuffer = XLSX.write(workbook, {
      type: 'array',
      bookType: 'xlsx',
    });

    // Convert the array buffer to a Blob
    const excelBlob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(excelBlob, `${fileName}.xlsx`);
  };

  return { exportToExcel };
};

export default useExportToExcel;
